import React from "react";
import { useLocation } from "react-router-dom";
import Config from "../../config";
import {
  Button,
  HollowButton,
  TextMessage,
  TextPrimary
} from "../../components";
import { isValidClaroAction, isValidRedirectUrl } from "../../utils/security";
import Globo from "../../assets/Globo/Globo";
import confeteSerpentina from "../../assets/ClaroOffer/icon-confete-serpentina.svg";
import {
  Actions,
  OfferContent,
  OfferDescription,
  OfferHeading,
  OfferPage,
  OfferTerms,
  OfferUnavailable,
  OfferUnavailableText
} from "./styles";
import { useQueryParams } from "../../hooks/queryParams";
import { LinkTerms } from "../TermsOfUse/styles";

export const buildProviderSelectionUrl = (
  continueUrl: string,
  serviceId = Config.CLARO_SERVICE_ID,
  providerId = Config.CLARO_PROVIDER_ID
) => {
  const url = new URL(`/${serviceId}`, window.location.origin);
  url.searchParams.set("url", continueUrl);
  url.searchParams.set("originProvider", providerId);

  return `${url.pathname}${url.search}${url.hash}`;
};

export const navigateTo = (
  url: string,
  location: Pick<Location, "replace"> = window.location
) => {
  location.replace(url);
};

const ClaroOffer = () => {
  const location = useLocation();
  const queryParams = useQueryParams();
  const continueUrl = queryParams.get("continueUrl");

  const hasValidRedirects =
    isValidClaroAction(window.location.origin, location.pathname) &&
    isValidRedirectUrl(continueUrl);

  const activate = () => {
    if (!hasValidRedirects || !continueUrl) {
      return;
    }

    navigateTo(buildProviderSelectionUrl(continueUrl));
  };

  const defer = () => {
    if (!hasValidRedirects || !continueUrl) {
      return;
    }

    navigateTo(continueUrl);
  };

  if (!hasValidRedirects) {
    return (
      <OfferPage>
        <OfferUnavailable>
          <Globo variant="conta" aria-label="Conta Globo" />
          <OfferUnavailableText>
            <TextPrimary>Oferta indisponível</TextPrimary>
            <TextMessage>
              Não foi possível validar o retorno desta oferta. Tente novamente
              pelo produto de origem.
            </TextMessage>
            <Button
              type="button"
              onClick={() => navigateTo(Config.DEFAULT_REDIRECT_URL)}
            >
              Voltar
            </Button>
          </OfferUnavailableText>
        </OfferUnavailable>
      </OfferPage>
    );
  }

  return (
    <OfferPage>
      <OfferContent>
        <Globo variant="conta" aria-label="Conta Globo" />

        <img
          src={confeteSerpentina}
          alt=""
          aria-hidden="true"
          width={96}
          height={96}
        />

        <OfferHeading>Seu benefício Globoplay está disponível!</OfferHeading>

        <OfferDescription>
          Aproveite seu <strong>acesso ao Globoplay</strong> através da Claro.
          Ative agora e comece a assistir seus conteúdos favoritos com sua Conta
          Globo.
        </OfferDescription>

        <Actions>
          <Button type="button" onClick={activate}>
            Ativar
          </Button>
          <HollowButton type="button" onClick={defer}>
            Prefiro deixar para depois
          </HollowButton>
        </Actions>

        <OfferTerms>
          Ao ativar, você concorda com os{" "}
          <LinkTerms href={Config.TERMS_OF_USE_URL} target="_blank">
            Termos de Uso
          </LinkTerms>{" "}
          e{" "}
          <LinkTerms href={Config.PRIVACY_POLICY_URL} target="_blank">
            Política de Privacidade
          </LinkTerms>
          .
        </OfferTerms>
      </OfferContent>
    </OfferPage>
  );
};

export default ClaroOffer;
